export default "__VITE_ASSET__DCvNC9Sm__"